import React, { useState, useEffect } from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // Import the Tippy CSS
import { FaDownload } from 'react-icons/fa';
import { PDFDocument, rgb, StandardFonts  } from 'pdf-lib';
import '../../Styles/Home.css';
import Notification from '../../Login/Components/Notification';
import { storeCustomerAndQuotes, generatePresignedUrl, getPresignedUrl, getInitialData, getQuestions, 
  getPaymentTerms, getBufferData, getEmails, sendQuoteMail, getPriorityOptions, getSpecialOptions, getSpecialPaymentTerm, 
  getSpecialPriorityOptions, sendMailToCustomer } from '../Services/index';
import { max } from 'moment/moment';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const env = process.env.REACT_APP_ENV;

export default function Home() {

  const [user, setUser] = useState('');
  const [customer, setCustomer] = useState({
    company_name: '',
    address: '',
    contact_person: '',
    mobile: '',
    email: '',
  });
  const [loader, setLoader] = useState(false);
  const [values, setValues] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [solution, setSolution] = useState('');
  const [solutionId, setSolutionId] = useState('');
  const [answerValue, setAnswerValue] = useState('');
  const [solutionList, setSolutionList] = useState([]);
  const [questions, setQuestions] = useState({});
  const [answers, setAnswers] = useState({});
  const [quote, setQuote] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [estimate, setEstimate] = useState({});
  const [manageServiceAmount, setManageServiceAmount] = useState('');
  const [minTotalCost, setminTotalCost] = useState('');
  const [maxTotalCost, setmaxTotalCost] = useState('');
  const [weightage, setWeightage] = useState([]);
  const [questionWeightage, setQuestionWeightage] = useState([]);
  const [answerWeightage, setAnswerWeightage] = useState([]);
  const [manageCost, setManageCost] = useState();
  const [optionId, setOptionId] = useState([]);
  const [specialPrice, setSpecialPrice] = useState();
  const [specialPaymentTerm, setSpecialPaymentTerm] = useState([]);
  const [noOfOptions, setNoOfOptions] = useState(0);
  const [specialOptionCount, setSpecialOptionCount] = useState(0);
  const [displayCalculation, setDisplayCalculation] = useState(false);
  const [selectedAnswerId, setSelectedAnswerId] = useState([]);
  const [paymentTerms, setPaymentTerms] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [isSaveButtonClicked, setIsSaveButtonClicked] = useState(false);
  const [attachment, setAttachment] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [generatedQuoteData, setGeneratedQuoteData] = useState();
  const [noOfSpecialOptions, setNoOfSpecialOptions] = useState(0);
  const [saveLoader, setSaveLoader] = useState(false);
  const [mailLoader, setMailLoader] = useState(false);

   useEffect(() => {
    const initialize = async () => {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
      await loadInitialData();
      const response = await getPaymentTerms(solutionId, [0])
      if(response){
        setPaymentTerms(response.payLoad)
      }
      const specialOptions = await getSpecialOptions(solutionId)
      if(specialOptions){
        const data = specialOptions[0]
        if(data !== undefined){
          setSpecialPrice(data.price)
          setNoOfOptions(data.numb_of_options)
          setNoOfSpecialOptions(data.numb_of_special_options)
        }
      }
    }
    initialize();
  }, [solutionId]);

  const loadInitialData = async () => {
    const result = await getInitialData(solutionId);
    if(result && result.status === 200) {
      await setSolutionList([...result.payLoad.solutions]);
      await setEstimate(result.payLoad.estimation);
    }
  }

  const handleNotificationClose = () => setShowNotification(false);

  const handleChange = (e) => {
        const { name, value } = e.target;
    
        // Regular expressions for validation
        const namePattern = /^[A-Za-z\s]*$/;
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
        // Initialize updated values for state and errors
        let updatedCustomer = { ...customer };
        let errors = { ...formErrors };
    
        // Check for empty input for all required fields
        if (!value.trim()) {
            errors[name] = 'Please fill in this field.';
        } else {
            // Clear the error if the field is not empty
            errors[name] = '';
        }
    
        // Validation for company_name and contact_person
        if (name === 'contact_person') {
            if (namePattern.test(value)) {
                updatedCustomer[name] = value;
                errors[name] = ''; // Clear error if valid
            } else {
                errors[name] = 'Only letters and spaces are allowed.';
            }
        }
    
        // Validation for mobile number
        else if (name === 'mobile') {
          // Allow only digits, +, -, and space
          const validCharacters = /^[+\-\d\s]*$/; // Regex to allow digits, +, -, and space
      
          if (!validCharacters.test(value)) {
              setNotificationMessage('Only digits, "+", "-", and spaces are allowed in the mobile number field.');
              setShowNotification(true);
              return;
          }
          // Update the field with the validated value
          updatedCustomer[name] = value;
        }
    
        // Validation for email
        else if (name === 'email') {
            updatedCustomer[name] = value;
            errors.email = emailPattern.test(value) ? '' : 'Please enter a valid email address.';
        }
    
        // Validation for address (example: require a minimum length of 5 characters)
        else if (name === 'address') {
            updatedCustomer[name] = value;
            errors.address = value ? '' : 'Please fill in this field.';
        }

        else if (name === 'company_name') {
          updatedCustomer[name] = value;
          errors.company_name = value ? '' : 'Please fill in this field.';
        }
    
        // Update state with new values and errors
        setCustomer(updatedCustomer);
        setFormErrors(errors);
      };
    
    // Add handleBlur function to show required field error when input is empty
    const handleBlur = (e) => {
      const { name, value } = e.target;
      let errors = { ...formErrors };
    
      if (!value.trim()) {
        errors[name] = 'Please fill in this field.';
      } else {
        errors[name] = '';
      }
    
      setFormErrors(errors);
    };

const handleSaveQuote = async () => { 
  if (quote) {
    if (!isChecked) {
      setNotificationMessage("Please accept the terms and conditions before saving.");
      setShowNotification(true);
    } else {
      setSaveLoader(true);
      try {
        let totalCost;
        if (solution === "Greenfield Landing Zone - Out-of-Box Solution") totalCost = `${minTotalCost}`;
        else totalCost = `${minTotalCost} - ${maxTotalCost}`;
        const attachment = await modifyAndUploadPdf();
        const response = await storeCustomerAndQuotes(quote, solution, customer, user.user_id, attachment,totalCost);
        setAttachment(attachment)
        setSaveLoader(true);
        setNotificationMessage("Quote saved successfully!");
        setSaveLoader(false);
        setShowNotification(true);
        setIsSaveButtonClicked(true)
      } catch (error) {
        setSaveLoader(false);
        setNotificationMessage(`Error: ${error.message}`);
        setShowNotification(true);
        console.error("Failed to save quote:", error);
      }
    }
  }
};

const handleSendMailToCustomer = async () => {
  if (quote){
    if(!isChecked){
      setNotificationMessage("Please save the quote before sending mail.");
      setShowNotification(true);
    }else if(isSaveButtonClicked === false){
      setNotificationMessage("Please save the quote before sending mail.");
      setShowNotification(true);
    }else{
      try{
        setMailLoader(true);
        const email = customerEmail;
        const quoteData = generatedQuoteData;
        let bucket;
        if(env === 'dev') bucket = 'dev-neviton-app-quote';
        else if(env === 'prod') bucket = 'prod-neviton-app-quote';
        const response = await sendMailToCustomer(email, quoteData, attachment, bucket);
        setNotificationMessage("Quotation Mailed to Customer!");
        setShowNotification(true);
        setMailLoader(false);
      }catch(err){
        console.log(err);
        setMailLoader(false);
        setNotificationMessage(`Error: ${err.message}`);
        setShowNotification(true);
      }
    }
  }
}

function formattedNewDate(isTimeRequired) {
  const date = new Date();
  const day = String(date.getDate()).padStart(2, '0');
  const monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  const month = monthNames[date.getMonth()]; // Get month name
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return isTimeRequired
    ? `${day} ${month} ${year}_${hours}-${minutes}-${seconds}`
    : `${day} ${month} ${year}`;
}

const modifyAndUploadPdf = async() => {
  const pdfBytes = await modifyQuotationTemplate();
  const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });  // Convert Uint8Array to Buffer for AWS S3
  const date = formattedNewDate(true);
  const fileName = `Quotation_${date}.pdf`;
  const response = await generatePresignedUrl(fileName, 'application/pdf');  
  if (response.status !== 201) {
    setLoader(false);
    throw new Error('Failed to get presigned URL');
  }
  const url  = response.payLoad;
  const uploadResponse = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/pdf'
    },
    body: pdfBlob
  });
  if (uploadResponse.ok) {
    return fileName;
  } else {
    setNotificationMessage(`Failed to upload Quotation in S3`);
    setShowNotification(true);
  }
}


const modifyQuotationTemplate = async () => {  
  const isMigration = solution === 'AWS Migration - Landing Zone to Control Tower' ? true : false;
  const isOutofBox = solution ==='Greenfield Landing Zone - Out-of-Box Solution' ? true : false; // to check for solution 3
  let bucket;
  if(env === 'dev') bucket = 'dev-neviton-app-quote';
  else if(env === 'prod') bucket = 'prod-neviton-app-quote';

  //depending on the solution selected , pdf will be downloaded
  const fileName = isMigration 
    ? 'assets/template/Sample_Quote_AWS_Migration_LandingZone_to_ControlTower_V1.0.pdf' 
    : isOutofBox 
      ? 'assets/template/Sample_Quote_GreenField_Out-of-Box_V1.0.pdf' 
      : 'assets/template/Sample_Quote_GreenField_LandingZone_V1.0.pdf';
  
  const response = await getPresignedUrl(bucket, fileName);
  const existingPdfBytes = await fetch(response.payLoad).then(res => res.arrayBuffer());
  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  const thirdPage = pages[2];
  const fourthPage = pages[3];
  const fifthPage = pages[4];
  const sixthPage = pages[5];

  // Convert specialPaymentTerm array to a single string
  const specialPaymentText = specialPaymentTerm.join(" ");
  
  const greenField_result = [
    {x: 180, y: 713.5},
    {x: 220, y: 646},
    {x: 210, y: 615},
    {x: 200, y: 585},
    {x: 108,  y: 561},
    {x: 126,  y: 328}
  ];
  const greenField_answers = [
    {x: 145, y: 573},
    {x: 145, y: 510},
    {x: 145, y: 450},
    {x: 145, y: 390},
    {x: 145, y: 330},
    {x: 145, y: 270},
    {x: 145, y: 210},
    {x: 145, y: 150},
    {x: 145, y: 90},
  ];
  const greenField_answers_continuation = [
    {x: 145, y: 715},
    {x: 145, y: 655},
  ]
  const migration_result = [
    {x: 180, y: 264},
    {x: 220, y: 197},
    {x: 210, y: 167},
    {x: 200, y: 136},
    {x: 108, y: 110},
    {x: 127, y: 570}
  ];
  const migration_answers = [
    {x: 145, y: 572},
    {x: 145, y: 514},
    {x: 145, y: 455},
    {x: 145, y: 398},
    {x: 145, y: 338},
    {x: 145, y: 281},
    {x: 145, y: 223},
    {x: 145, y: 164},
    {x: 145, y: 106},
  ];
  const migration_answers_continuation = [
    {x: 145, y: 741},
    {x: 145, y: 685},
    {x: 145, y: 628},
    {x: 145, y: 570},
    {x: 145, y: 511},
    {x: 145, y: 454},
    {x: 145, y: 395},
    {x: 145, y: 338},
    {x: 145, y: 278},
    {x: 145, y: 222},
    {x: 145, y: 164},
    {x: 145, y: 106},
  ]

  const out_of_box_answers =[
    {x: 165, y: 545}
  ]

  const out_of_box_results = [
    {x: 220, y: 725},  //timeline
    {x: 230, y: 648},   //price
    {x: 230, y: 628},   //managed service
    {x: 230, y: 608} //total cost
  ]

  const questions = Object.keys(answers);
  const helveticaBoldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
  const date = formattedNewDate(false);

//first page , date , qoute generated by ..
  firstPage.drawText(date, {
    x: 235,
    y: 495,
    size: 22,
    font: helveticaBoldFont,
    color: rgb(0, 0, 0), // Black color
  });
  firstPage.drawText(customer.company_name, {
    x: 250,
    y: 390,
    size: 16,
    font: helveticaBoldFont,
    color: rgb(0, 0, 0), // Black color
  });

  // Helper function to wrap text
  const wrapText = (text, font, fontSize, maxWidth) => {
    if (!text || typeof text !== 'string') {
      return []; // Return an empty array if text is invalid
    }
    const words = text.split(' ');
    let lines = [];
    let currentLine = words[0];

    for (let i = 1; i < words.length; i++) {
      const word = words[i];
      const width = font.widthOfTextAtSize(`${currentLine} ${word}`, fontSize);
      if (width < maxWidth) {
        currentLine += ` ${word}`;
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    }
    lines.push(currentLine); 
    return lines;
  };

  // Function to draw wrapped text
  const drawWrappedText = (page, text, x, y, font, fontSize, lineHeight, maxWidth) => {
    const lines = wrapText(text, font, fontSize, maxWidth);
    lines.forEach((line, index) => {
      page.drawText(line, {
        x: x,
        y: y - index * lineHeight, // Adjust Y position for each line
        size: fontSize,
        font: font,
        color: rgb(0, 0, 0), // Black color
      });
    });
  };

  // Use standard Helvetica font instead of bold
  const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);


  //check if solution is Out-of-Box 
if(isOutofBox){
  //to display the answer selected

      // Get the last question for Out-of-Box Solution
      const lastQuestionIndex = questions.length - 1;
      const lastQuestionKey = questions[lastQuestionIndex]; // Last question key
      const lastQuestionAnswer = answers[lastQuestionKey] || 'N/A'; // Default if undefined

      // Only process the last question's answer
      out_of_box_answers.forEach((pos, ind) => {
        if (ind === out_of_box_answers.length - 1) { // Ensure it's the last question
          const answerText = `${lastQuestionAnswer}${manageCost ? ` [$${manageCost} /month] ` : ''}`;

          if (answerText.trim()) {
            drawWrappedText(
              fourthPage,
              answerText.trim(), // Ensure no extra whitespace
              pos.x,             // X coordinate
              pos.y,             // Y coordinate
              helveticaBoldFont, // Font
              10,                // Font size
              14,                // Line height
              380               // Maximum width
            );
          }
        }
      });

    //to display the estimated timeline,price and managed service cost and total cost.
    fifthPage.drawText(quote.timeline, {
      x: out_of_box_results[0].x,
      y: out_of_box_results[0].y,
      size: 12,
      font: helveticaBoldFont,
      color: rgb(0, 0, 0), // Black color
    });
    fifthPage.drawText(quote.price, {
      x: out_of_box_results[1].x,
      y: out_of_box_results[1].y,
      size: 12,
      font: helveticaBoldFont,
      color: rgb(0, 0, 0), // Black color
    });
    if (manageServiceAmount) {
      const formattedServiceAmount = `$${manageServiceAmount}`; // Add the $ symbol
      fifthPage.drawText(formattedServiceAmount, {
        x: out_of_box_results[2].x,
        y: out_of_box_results[2].y,
        size: 12,
        font: helveticaBoldFont,
        color: rgb(0, 0, 0), // Black color
      });
    }
    if (minTotalCost) {
      const costRange = `$${minTotalCost}`; // Create the formatted string
      fifthPage.drawText(costRange, {
        x: out_of_box_results[3].x,
        y: out_of_box_results[3].y,
        size: 12,
        font: helveticaBoldFont,
        color: rgb(0, 0, 0),
      });
    }

  }
   //check if solution is Out-of-Box 
  else if(isMigration) {
    fifthPage.drawText(quote.timeline, {  //quote : contains timeline and estimated quote price calculated
      x: migration_result[0].x,
      y: migration_result[0].y,
      size: 12,
      font: helveticaBoldFont,
      color: rgb(0, 0, 0), // Black color
    });
    fifthPage.drawText(quote.price, { // estimated cost inserted into the document
      x: migration_result[1].x,
      y: migration_result[1].y,
      size: 12,
      font: helveticaBoldFont,
      color: rgb(0, 0, 0), // Black color
    });
    if (manageServiceAmount) { // if manage service cost exists then insert into the document
      const formattedServiceAmount = `$${manageServiceAmount}`; // Add the $ symbol
      fifthPage.drawText(formattedServiceAmount, {
        x: migration_result[2].x,
        y: migration_result[2].y,
        size: 12,
        font: helveticaBoldFont,
        color: rgb(0, 0, 0), // Black color
      });
    }
    if (minTotalCost && maxTotalCost) { // if total cost exists then insert into the document
      const costRange = `$${minTotalCost} - $${maxTotalCost}`; // Create the formatted string
      fifthPage.drawText(costRange, {
        x: migration_result[3].x,
        y: migration_result[3].y,
        size: 12,
        font: helveticaBoldFont,
        color: rgb(0, 0, 0), // Black color
      });
    }
    if (specialPaymentTerm) {
      // If specialPaymentTerm exists and is non-empty, display the first element
      drawWrappedText(
        fifthPage,
        specialPaymentTerm[0],        // First element of the array
        migration_result[4].x,       // X coordinate
        migration_result[4].y,       // Y coordinate
        helveticaBoldFont,            // Font
        10,                           // Font size
        14,                           // Line height
        420                           // Maximum width
      );
    }
  
     // Add wrapping logic for greenField_answers
     //to display options selected under the equestions
     migration_answers.forEach((pos, ind) => {
      drawWrappedText(
        thirdPage,
        answers[questions[ind]], // Text to display
        pos.x,                  // X coordinate
        pos.y,                  // Y coordinate
        helveticaBoldFont,      // Font
        10,                     // Font size
        14,                     // Line height
        420                     // Maximum width
      );
    });

    // Add wrapping logic for migration_answers_continuation
    migration_answers_continuation.forEach((pos, ind) => {
      const continuationIndex = ind + 9; // Shift the index for questions 10 and 11
      const answerKey = questions[continuationIndex];
      const answer = answers[answerKey] || 'N/A'; // Provide default if undefined
      const isLastQuestion = ind === migration_answers_continuation.length - 1;
      const answerText = `${answer}${
        isLastQuestion && manageCost ? ` [$${manageCost} /month] ` : ''
      }`;

      if (answerText.trim()) {
        drawWrappedText(
          fourthPage,
          answerText.trim(),
          pos.x,
          pos.y,
          helveticaBoldFont,
          10,
          14,
          420
        );
      }
    });

  } else { //for greenfield solution
    fifthPage.drawText(quote.timeline, {
      x: greenField_result[0].x,
      y: greenField_result[0].y,
      size: 12,
      font: helveticaBoldFont,
      color: rgb(0, 0, 0), // Black color
    });
    fifthPage.drawText(quote.price, {
      x: greenField_result[1].x,
      y: greenField_result[1].y,
      size: 12,
      font: helveticaBoldFont,
      color: rgb(0, 0, 0), // Black color
    });
    if (manageServiceAmount) {
      const formattedServiceAmount = `$${manageServiceAmount}`; // Add the $ symbol
      fifthPage.drawText(formattedServiceAmount, {
        x: greenField_result[2].x,
        y: greenField_result[2].y,
        size: 12,
        font: helveticaBoldFont,
        color: rgb(0, 0, 0), // Black color
      });
    }
    if (minTotalCost && maxTotalCost) {
      const costRange = `$${minTotalCost} - $${maxTotalCost}`; // Create the formatted string
      fifthPage.drawText(costRange, {
        x: greenField_result[3].x,
        y: greenField_result[3].y,
        size: 12,
        font: helveticaBoldFont,
        color: rgb(0, 0, 0), // Black color
      });
    }
    if (specialPaymentTerm) {
      // If specialPaymentTerm exists and is non-empty, display the first element
      drawWrappedText(
        fifthPage,
        specialPaymentTerm[0],        // First element of the array
        greenField_result[4].x,       // X coordinate
        greenField_result[4].y,       // Y coordinate
        helveticaBoldFont,            // Font
        10,                           // Font size
        14,                           // Line height
        420                           // Maximum width
      );
    } 
    
    // Add wrapping logic for greenField_answers
    greenField_answers.forEach((pos, ind) => {
      drawWrappedText(
        thirdPage,
        answers[questions[ind]], // Text to display
        pos.x,                  // X coordinate
        pos.y,                  // Y coordinate
        helveticaBoldFont,      // Font
        10,                     // Font size
        14,                     // Line height
        420                     // Maximum width
      );
    });

    // Add wrapping logic for greenField_answers_continuation
    greenField_answers_continuation.forEach((pos, ind) => {
      const continuationIndex = ind + 9; // Shift the index for questions 10 and 11
      const answerKey = questions[continuationIndex];
      const answer = answers[answerKey] || 'N/A'; // Provide default if undefined
      const isLastQuestion = ind === greenField_answers_continuation.length - 1; // Check for last question
      const answerText = `${answer}${
        isLastQuestion && manageCost ? ` [$${manageCost} /month] ` : ''
      }`;

      if (answerText.trim()) {
        drawWrappedText(
          fourthPage,
          answerText.trim(), // Ensure no extra whitespace
          pos.x,             // X coordinate
          pos.y,             // Y coordinate
          helveticaBoldFont, // Font
          10,                // Font size
          14,                // Line height
          420                // Maximum width
        );
      }
    });

  }
  const pdfBytes = await pdfDoc.save();
  return pdfBytes;
}

const handlePDFDownload = async () => {
  if (!isChecked) {
    setNotificationMessage("Please accept the terms and conditions before saving.");
    setShowNotification(true);
  } else {
    try {
        const allDetailsFilled = Object.values(customer).every((detail) => detail !== '');
        const allMandatoryQuestionsAnswered = questions[solution].every((question) => {
          if (question.mandatory) {
            return answers[question.question] !== undefined; // Ensure the answer is selected
          }
          return true; // Skip optional questions
        });
        if (allDetailsFilled && allMandatoryQuestionsAnswered) { 
          const pdfBytes = await modifyQuotationTemplate();
          const blob = new Blob([pdfBytes], { type: 'application/pdf' });
          const urlForBlob = URL.createObjectURL(blob);

          // Trigger a download of the modified PDF
          const link = document.createElement('a');
          link.href = urlForBlob;
          const date = formattedNewDate(true);
          link.download = `Quotation ${date}.pdf`;
          link.click();

          // Release the object URL after download
          URL.revokeObjectURL(urlForBlob);
        } else {
          setNotificationMessage("Please fill in all customer details and answer all mandatory questions.");
          setShowNotification(true);
          setLoader(false)
        }
      } catch (err) {
        console.error(err);
      }
    }
  }

  const handleAnswerChange = async (question, answer, answerWeightage, answerValue, answerId) => {
    setIsSaveButtonClicked(false);
    setIsChecked(false);
    setQuote(null);
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
        [question]: answer,
    }));
    setSelectedAnswerId((prevAnswers) => ({
      ...prevAnswers,
        [question]: answerId,
    }));
    setValues((prevAnswers) => ({
      ...prevAnswers,
        [question]: answerWeightage,
    }));
    setAnswerValue(answerValue);
    if(answerValue !== null ){
      await setManageCost(answerValue)
    }
    setOptionId((preOptionWeigthages) => ({
      ...preOptionWeigthages,
      [question]: answerId,  
    }));
  };

  const handleSolutionChange = async (e) => {
    setIsSaveButtonClicked(false);
    setIsChecked(false);
    setAnswers({});
    setSelectedAnswerId([]);
    setValues({});
    setQuote(null);

    const selectedValue = e.target.value;
    const selectedSolution = solutionList.find((sol) => sol.solutionName === selectedValue);
    setSolutionId(selectedSolution.solutionId);

    const result = await getQuestions(selectedSolution.solutionId);  

    if(result && result.status === 200) {
      const formattedQuestions = result.payLoad.map((question) => ({
        ...question,
        options: question.options.map(option => ({
          ...option,
          suboptions: option.suboptions || [] // Ensure suboptions exist
        }))
      }));
      
      setQuestions({[selectedValue]: formattedQuestions});
      setSolution(selectedValue);
    }
};


  const handleGenerateQuote = async () => {
    setLoader(true);
    const questionsWightage = {};
    const questionsContribution = {};
    let totalContribution = 0;
    const allDetailsFilled = Object.values(customer).every((detail) => detail !== '');

  //Solution 3
  if (solution === "Greenfield Landing Zone - Out-of-Box Solution") {
    // Get the last question and set it as mandatory
    const lastQuestion = questions[solution][questions[solution].length - 1]; 
    const allMandatoryQuestionsAnswered = answers[lastQuestion.question] !== undefined;
    
    if (allDetailsFilled){
      if(allMandatoryQuestionsAnswered) {
        const estimatedCost = estimate.maxCostStart;
        const estimatedTimeline = estimate.maxWeeks;
        // Set initial estimated values
        setQuote({
          timeline: `${estimatedTimeline} Weeks`,
          price: `$${estimatedCost}`
        });   

        const lastQuestionAnswer = {
          [lastQuestion.question]: answers[lastQuestion.question]
        };
  
        await setAnswers(lastQuestionAnswer);

        const setData = async (manageCost, minCost, duration) => {
          const formattedManageServiceAmount = new Intl.NumberFormat('en-US', { 
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(manageCost * duration);
    
          const formattedMinTotalCost = new Intl.NumberFormat('en-US', { 
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(Number(minCost) + manageCost * duration);

          await setManageServiceAmount(formattedManageServiceAmount);  // will set the calculated manages service 
          await setminTotalCost(formattedMinTotalCost);
        };
        let priceForManageCost = [];
        // Dynamically get the last question
        const lastQuestionIndex = questions[solution].length - 1;
        const lastQuestionOptions = questions[solution][lastQuestionIndex].options;
        
        // Extract the answerValue from the last question's options
        for (let i = 0; i < lastQuestionOptions.length; i++) {
          priceForManageCost[i] = lastQuestionOptions[i].answerValue;
        }
    
        // Iterate through priceForManageCost and find a match with manageCost
        for (let i = 0; i < priceForManageCost.length; i++) {
          if (Number(manageCost) === Number(priceForManageCost[i])) {
            // Cycle through 3, 6, and 9 months
            const monthsArray = [3, 6, 12];
            const months = monthsArray[Math.min(i, monthsArray.length - 1)]; // Ensure it doesn't exceed 9
        
            // Call the async setData function with the calculated values
            await setData(Number(manageCost), estimatedCost, months);
            break; // Exit the loop once a match is found
          }
        }
        setAnswerWeightage(Object.values(values));
        setLoader(false);
        const generatedQuoteData = {
          quote: quote,
          firstName: user.first_name,
          lastName: user.last_name,
          customer: customer,
          companyName: customer.company_name,
          timeline: `${estimatedTimeline}Weeks`,
          cost: `${estimatedCost}`,
          solutionName: solution,
          selectedAnswers: answers,
          manageServiceCost: manageServiceAmount,
          totalCost: `${minTotalCost}`
        }
        await setCustomerEmail(customer.email)
        await setGeneratedQuoteData(generatedQuoteData)
        setGeneratedQuoteData(generatedQuoteData);
        // Fetch emails and send the quote email
        const emails = await listOfEmails();
        const response = await sendMail(emails, generatedQuoteData);
        console.log("Mail sent:", response);
        } else {
          callNotification("Please answer the question.");
        }
      }else {
        callNotification("Please fill in all customer details.");
      }
     
    }
    else{
      const allMandatoryQuestionsAnswered = questions[solution].every((question) => {
        questionsWightage[question.question] = question.questionWeightage;
          return answers[question.question] !== undefined; // Ensure the answer is selected
      });
      if (allDetailsFilled){
        if(allMandatoryQuestionsAnswered) {
        for(let question in answers){
          questionsContribution[question] = (questionsWightage[question] * values[question]) / 100;
          totalContribution = totalContribution + (questionsWightage[question] * values[question]) / 100;
        }
        const quote = Math.round(Number(estimate.minCostStart) * (totalContribution / 100));
          const priorityOptions = await getPriorityOptions();
          let priorityListOptions = [];
          for(let i=0; i<priorityOptions.data.payLoad.length; i++){
            priorityListOptions.push(priorityOptions.data.payLoad[i]);
          }
          let questionToLocal = []
          questions[solution].map((question, index) => {
            questionToLocal[index] = question.question;
          })

          const sortedAnswers = questionToLocal.reduce((result, question) => {
            if (answers[question]) {
                result[question] = answers[question];
            }
            return result;
          }, {});
          await setAnswers(sortedAnswers);
          const optionIds = Object.values(selectedAnswerId);
          let localCount;
          const checkSpecialOptionCase = async () => {
            localCount = 0;
             for(let i = 0; i<optionIds.length; i++){
              for(let j=0; j<priorityListOptions.length; j++){
                if(optionIds[i] === priorityListOptions[j]){
                  localCount = localCount + 1;
                }
              }
              if (localCount >= Number(noOfOptions)) {
                await setSpecialOptionCount(localCount);
              }
            }
          };

        await checkSpecialOptionCase()
        let finalQuote = 0;
        if(localCount >= Number(noOfOptions)){
          const specPaymentTerm = await getSpecialPaymentTerm(solutionId);
          setSpecialPaymentTerm(specPaymentTerm)
          finalQuote = ((quote < Number(estimate.minCost) ? Number(estimate.minCost) : quote) + Number(specialPrice));
          setDisplayCalculation(true);
        }else{
          setSpecialPaymentTerm([])
          finalQuote = ((quote < Number(estimate.minCost) ? Number(estimate.minCost) : quote));
          setDisplayCalculation(false);
        }
        const roundOff = () => {
          if(!Number.isInteger(finalQuote/1000)){
            return Math.round(finalQuote / 1000) * 1000;
          }else
            return finalQuote;
        }
        const finalQuoteRoundedValue = await roundOff();
        const minFormattedFinalQuote = new Intl.NumberFormat('en-US', { 
          style: 'currency', 
          currency: 'USD' ,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(finalQuoteRoundedValue);

        let bufferData = await getBufferData(solutionId);
        let weightage = []
        let questionWeightage = []
        let minTotalContribution = 0;
        for(let i=0; i<questions[solution].length; i++ ){
          weightage[i] = (questions[solution][i].options[0].answerWeightage)
          questionWeightage[i] = (questions[solution][i].questionWeightage)
        }
        if(weightage.length === questionWeightage.length){
          for(let i=0; i<weightage.length; i++){
              minTotalContribution = minTotalContribution + ((weightage[i]*questionWeightage[i])/100)
          } 
        }
        setWeightage(weightage)
        setQuestionWeightage(questionWeightage)
        await setOptionId([]);

        let minFinalTimeline = Math.round(Number(estimate.minWeeksMinimum) + (((totalContribution / 100) - minTotalContribution/100) / (1 - minTotalContribution/100)) * (Number(estimate.maxWeeks) - Number(estimate.minWeeksMinimum)));
    
        let maxFinalTimeline = (+minFinalTimeline) + (+bufferData[0]);
        
        let maxFinalQuote;
        const specialOptionIds = await getSpecialPriorityOptions();
        let specialOptionCount = 0;
        for(let i = 0; i<optionIds.length; i++){
            for(let j = 0; j<specialOptionIds.length; j++){
              if(optionIds[i] === specialOptionIds[j]){
                specialOptionCount = specialOptionCount + 1;
              }
            }
        }

        if(Number(finalQuoteRoundedValue) === Number(estimate.minCostStart)){
          if(specialOptionCount === noOfSpecialOptions){
            maxFinalQuote = ((Number(Math.round(quote / 1000) * 1000))+(Number((bufferData[2]/100))*(Number(Math.round(quote / 1000) * 1000)))+ Number(specialPrice));
          }else{
            maxFinalQuote = ((Number(Math.round(quote / 1000) * 1000))+(Number((bufferData[1]/100))*(Number(Math.round(quote / 1000) * 1000)))+ Number(specialPrice));;
          }
        }
        else{
          // checking 8,4,3,2 questions special option selected
            if(specialOptionCount === noOfSpecialOptions){
              maxFinalQuote = ((Number(Math.round(quote / 1000) * 1000))+(Number((bufferData[2]/100))*Number(Math.round(quote / 1000) * 1000))+ Number(specialPrice));
            }else{
              maxFinalQuote = ((Number(Math.round(quote / 1000) * 1000))+(Number((bufferData[1]/100))*Number(Math.round(quote / 1000) * 1000)));
              if(localCount >= Number(noOfOptions)){
                if(specialOptionCount >= noOfSpecialOptions){
                  maxFinalQuote = ((Number(Math.round(quote / 1000) * 1000))+(Number((bufferData[2]/100))*Number(Math.round(quote / 1000) * 1000))+ Number(specialPrice));
                }else{
                  maxFinalQuote = ((Number(Math.round(quote / 1000) * 1000))+(Number((bufferData[1]/100))*Number(Math.round(quote / 1000) * 1000))+ Number(specialPrice));
                }
              }else if(Number(finalQuoteRoundedValue>estimate.minCostStart)){
                maxFinalQuote = ((Number(Math.round(quote / 1000) * 1000))+(Number((bufferData[1]/100))*Number(Math.round(quote / 1000) * 1000)));
              }else if(Number(finalQuoteRoundedValue>estimate.minCostStart)){
                maxFinalQuote = ((Number(Math.round(quote / 1000) * 1000))+(Number((bufferData[1]/100))*Number(Math.round(quote / 1000) * 1000))+ Number(specialPrice));
              }else if(specialOptionCount === noOfSpecialOptions){
                maxFinalQuote = ((Number(Math.round(quote / 1000) * 1000))+(Number((bufferData[2]/100))*Number(Math.round(quote / 1000) * 1000))+ Number(specialPrice));
              }
            }
        }
         

        if(minFinalTimeline>Number(estimate.minWeeksMaximum)){
          minFinalTimeline = Number(estimate.minWeeksMaximum)
          maxFinalTimeline = Number(estimate.maxWeeks)
        }

        const maxFormattedFinalQuote = new Intl.NumberFormat('en-US', { 
          style: 'currency', 
          currency: 'USD' ,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(maxFinalQuote);
        setQuote({timeline: `${minFinalTimeline} - ${maxFinalTimeline} Weeks`, price: `${minFormattedFinalQuote} - ${maxFormattedFinalQuote}` , sum: totalContribution});
        const emails = await listOfEmails();
        const setData = async (manageCost, finalRoundCost, finalCost, duration) => {
          await setManageServiceAmount(new Intl.NumberFormat('en-US', { 
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(manageCost*duration));
          await setminTotalCost(new Intl.NumberFormat('en-US', { 
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(Number(finalRoundCost) +  manageCost*duration));
          await setmaxTotalCost(new Intl.NumberFormat('en-US', { 
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(Number(finalCost)+  manageCost*duration));
        }

        let priceForManageCost = [];

        setLoader(false);

        // Dynamically get the last question
        const lastQuestionIndex = questions[solution].length - 1;
        const lastQuestionOptions = questions[solution][lastQuestionIndex].options;
        // Extract the answerValue from the last question's options
        for (let i = 0; i < lastQuestionOptions.length; i++) {
          priceForManageCost[i] = lastQuestionOptions[i].answerValue;
        }

        // Iterate through priceForManageCost and find a match with manageCost
        for (let i = 0; i < priceForManageCost.length; i++) {
          if (Number(manageCost) === Number(priceForManageCost[i])) {
            // Calculate months based on index
            const months = (i === priceForManageCost.length - 1)
              ? (priceForManageCost.length) * 3
              : i * 3;

            // Call the async setData function with the calculated values
            await setData(Number(manageCost), finalQuoteRoundedValue, maxFinalQuote, months);
            break; // Exit the loop once a match is found
          }
        }
        setAnswerWeightage(Object.values(values));
        const generatedQuoteData = {
          quote: quote,
          firstName: user.first_name,
          lastName: user.last_name,
          customer: customer,
          companyName: customer.company_name,
          timeline: `${minFinalTimeline} - ${maxFinalTimeline} Weeks`,
          cost: `${minFormattedFinalQuote} - ${maxFormattedFinalQuote}`,
          solutionName: solution,
          selectedAnswers: answers,
          manageServiceCost: manageServiceAmount,
          totalCost: `${minTotalCost} - ${maxTotalCost}`
        }
        await setCustomerEmail(customer.email)
        await setGeneratedQuoteData(generatedQuoteData)
        const response = await sendMail(emails, generatedQuoteData)   
      }else{
        callNotification("Please answer all mandatory questions.");
      }
    } 
      else {
        callNotification("Please fill in all customer details.");
      }
    }
  };

  const callNotification = (msg) =>{
    setNotificationMessage(msg);
    setShowNotification(true);
    setLoader(false);
  }

  const listOfEmails = async () => {
    const response = await getEmails()
    return response;
  }

  const sendMail = async (emails, generatedQuoteData) =>{
      try{
        const response = await sendQuoteMail(emails, generatedQuoteData)
        return response;
      }catch(err){
        console.log(err);
      }
  }

  return (
    <div className="container">
      <div className="page-container">
        <div className="customer-details">
      {/* Customer details */}
          <h2>Customer Details</h2>
          <div className="customer-inputs">
            <div className='input-wrapper'>
              <input
                type="text"
                name="company_name"
                value={customer.company_name}
                onChange={handleChange}
                placeholder="Company Name"
                className="input"
                onBlur={handleBlur} // Add onBlur handler
                required
              />
              <span style={{ color: 'red' }}>*</span>
              {formErrors.company_name && <ErrorPopup message={formErrors.company_name} />}
            </div>

            <div className='input-wrapper-address'>
              <input
                type="text"
                name="address"
                value={customer.address}
                onChange={handleChange}
                placeholder="Address"
                className="address-input"
                onBlur={handleBlur} // Add onBlur handler
                required
              />
              <span style={{ color: 'red' }}>*</span>
              {formErrors.address && <ErrorPopup message={formErrors.address} />}
            </div>

            <div className='input-wrapper'>
              <input
                type="text"
                name="contact_person"
                value={customer.contact_person}
                onChange={handleChange}
                placeholder="Contact Person"
                className="input"
                onBlur={handleBlur} // Add onBlur handler
                required
              />
              <span style={{ color: 'red' }}>*</span>
              {formErrors.contact_person && <ErrorPopup message={formErrors.contact_person} />}
            </div>

            <div className='input-wrapper'>
              <input
                type="text"
                name="mobile"
                value={customer.mobile}
                onChange={handleChange}
                placeholder="Contact Number"
                className="input"
                onBlur={handleBlur} // Add onBlur handler
                required
              />
              <span style={{ color: 'red' }}>*</span>
              {formErrors.mobile && <ErrorPopup message={formErrors.mobile} />}
            </div>

            <div className='input-wrapper'>
              <input
                type="email"
                name="email"
                value={customer.email}
                onChange={handleChange}
                placeholder="Email"
                className="input"
                onBlur={handleBlur} // Add onBlur handler
                required
              />
              <span style={{ color: 'red' }}>*</span>
              {formErrors.email && <ErrorPopup message={formErrors.email} />}
            </div>
          </div>
        </div>
{/* SELECT */}
        <section className="solution-selection">
          <h3>Select a Solution</h3>
          <select value={solution} onChange={handleSolutionChange}>
            <option value="">Select Solution</option>
            {solutionList.slice(0,3).map((sol) => (  //retreives only the first 2 solutions
              <option key={sol.solutionId} value={sol.solutionName}>{sol.solutionName}</option>
            ))}
          </select>
        </section>

{/* Main Content Section */}
{solution && (
  <div className="main-content">
    <div className="questions-container">
      <>
        {questions[solution].map((item, index) => (
          <div className="question-group" key={index}>
            {/* Tooltip with question number and description */}
            <p>
              {`${index + 1}. ${item.question}`} {/* Add question number */}
              {item.mandatory && <span style={{ color: "red" }}>*</span>}
            </p>

            <div className="options">
              {item.options.map(
                ({ answer, answerWeightage, answerValue, answerId, suboptions,tooltip }, i) => {
                  const [boldText, restText] = answer.split(/:(.+)/);

                  // Check if it is solution 3
                  return solution === "Greenfield Landing Zone - Out-of-Box Solution" && item.sequence !== 9 ? ( 
                    <div key={i}>
                      <ul className="cursor-default">
                        <li className="clickable-option">
                        {boldText}
                          {restText ? `: ${restText}` : ""}
                          {answerValue !== null && answerValue !== undefined && ` [$${answerValue}/month].`}
                        </li>
                        {boldText && !boldText.trim().endsWith(".") && !boldText.trim().endsWith(":") && "."}
                        {boldText && !boldText.endsWith(':') ? (
                          <Tippy content={tooltip} placement="bottom" arrow={true} className="custom-tippy">
                            <InfoOutlinedIcon style={{ fontSize: 12, color: '#043c7b' }} />
                          </Tippy>
                        ) : null}

                      </ul>

                      {/* Render suboptions if available */}
                      {suboptions && suboptions.length > 0 && (
                        <ul className="suboptions">
                          {suboptions.map(({ suboptionId, suboptionDetails, tooltip }) => (
                            <li key={suboptionId} className="suboption-text">
                              {suboptionDetails}
                              {suboptionDetails && !suboptionDetails.trim().endsWith(".") && !suboptionDetails.trim().endsWith(":") && "."}
                              <Tippy content={tooltip} placement="bottom" arrow={true} className="custom-tippy">
                                <InfoOutlinedIcon style={{ fontSize: 12, color: '#043c7b' }} />
                              </Tippy>
                            </li>
                          ))}

                        </ul>
                      )}
                    </div>
                  ) : (
                    // Other 2 solutions
                    <div key={i} className="option-container">
                      <label>
                        <input
                          type="radio"
                          name={item.question}
                          value={answer}
                          checked={answers[item.question] === answer}
                          onChange={() =>
                            handleAnswerChange(
                              item.question,
                              answer,
                              answerWeightage,
                              answerValue,
                              answerId
                            )
                          }
                          required={item.mandatory}
                        />
                        <span>
                          <strong className="bold-option-text">{boldText}</strong>
                          {restText ? (restText.endsWith(':') ? `: ${restText}` : restText.trim().endsWith('.') ? `: ${restText}` : `: ${restText}`) : ""}
                          {answerValue !== null && answerValue !== undefined ? ` [$${answerValue}/month]` : ""}
                          {((restText && !restText.endsWith('.')) || answerValue !== null) ? "." : ""}
                        </span>
                        <Tippy content={tooltip} placement="bottom" arrow={true} className="custom-tippy">
                          <InfoOutlinedIcon style={{ fontSize: 12, color: '#043c7b' }} />
                        </Tippy>
                      </label>
                    </div>
                  );
                }
              )}
            </div>
          </div>
        ))}
      </>
    </div>
  </div>
)}

      {solution && (
        <div className="quote-button-container">
            <Tippy content="Click to generate a quote based on your answers" placement="top" arrow={null}>
              <button className="button" onClick={handleGenerateQuote}>
                {loader ? 'Generating...' : 'Generate Quote'}
              </button>
            </Tippy>
        </div>
      )}

      {/* {quote && answerWeightage && questionWeightage && (
       <>
         <h4>Calculation</h4>
         <ol className="calculation-list">
           {(() => {
             let listItems = [];
             let sum = 0;
             for (let i = 0; i < answerWeightage.length; i++) {
               let weight = answerWeightage[i];
               let questionWeight;
               for (let j = i; j < questions[solution].length; j++) {
                 questionWeight = questionWeightage[j];
                 break;
               }
               const result = (weight * questionWeight) / 100;
               listItems.push(
                 <li key={i} className="calculation-item">
                   {weight} * {questionWeight} / 100 = {result}
                 </li>
               );
               sum = Number(result) + Number(sum);
             }
             listItems.push(
               <li key="sumValue" className="calculation-item">
                 sum = {sum}
               </li>
             );
             if(displayCalculation){
               listItems.push(
                 <li key="specialOptionSelection" className="calculation-item">
                   <>
                   <b>Special option selected </b>
                   </>
                 </li>
               );
             }
             listItems.push(
               <li key="specialOptionPriceDisplay" className="calculation-item">
                 <>
                    <b>Final Quotation price</b> = {quote.price}
                 </>
               </li>
             );
             return listItems;
           })()}
         </ol>
       </>
     )}  */}
    </div>

    <div className="vertical-divider"></div>

    {/* Quote Section */}
    <div className="parent-container">
      <div className="quote-container">
        <div className="quote-header">
          <h3>Quote</h3>
          <Tippy content="Download Quotation" placement="top-start" arrow={false}>
            <FaDownload className="download-icon" onClick={handlePDFDownload} />
          </Tippy>
        </div>
        {quote && (
          <div className="quote-content">      
            <p><strong>{solution}</strong></p>
            <div className="quote-details">
              <p>Estimated Time <span className="result-box">{quote.timeline}</span></p>
              <p>
              Estimated Migration Cost
                <span className="result-box">{quote.price}</span>
              </p>
              {manageServiceAmount !== null && (<p>Managed Services Cost<span className="result-box">${manageServiceAmount}</span></p>)}
              {solution==="Greenfield Landing Zone - Out-of-Box Solution" ? (<p>
                  Total Estimated Cost
                    <span className="result-box">${minTotalCost}</span>
                  </p>)
              :
              (<p>
                Total Estimated Cost*
                  <span className="result-box">${minTotalCost} - ${maxTotalCost}</span>
                </p>
            )}
              {specialOptionCount >= noOfOptions && specialPaymentTerm.length > 0 && (
                <ul className="special-payment-term">
                  {specialPaymentTerm.map((term, index) => (
                    <li className='termData' key={index}>{term}</li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        )}
      </div>

      {/* New div container */}
      {quote && (
        <div className="additional-container">
          <h4>Terms & Conditions</h4>
          <ol>
            {paymentTerms.map((term, index) => (
              <li key={index}>{term}</li>
            ))}
          </ol>
        </div>
      )} 

      {/* Checkbox Container */}
      {quote && ( 
        <div className="checkbox-container">
          <input
          className='checkbox'
            type="checkbox"
            id="terms"
            checked={isChecked}
            onChange={() => setIsChecked(!isChecked)}
          />
          <label htmlFor="terms">
            <strong>I accept the Terms & Conditions</strong>
          </label>
        </div>
      )}

      {/* Save Button Container */}
      {quote && (
        <div className="button-container">
          {/* Tippy Tooltip for Save Button */}
          <Tippy content={"Save Quotation"} placement="top-start" arrow={null}>
            <button
              className="save-button"
              onClick={handleSaveQuote}
            >
              {saveLoader ? 'Saving...' : 'Save'}
            </button>
          </Tippy>
        </div>
      )}
      {quote && (
              <div >
                {/* Tippy Tooltip for Save Button*/}
                <Tippy content={"Send Mail to Customer"} placement="top-start" arrow={null}>
                  <button
                    className="mail-button"
                    onClick={handleSendMailToCustomer}
                  >
                    {mailLoader ? 'sending...' : 'Send mail'}
                  </button>
                </Tippy>
              </div>
        )} 
    </div>

            

    
    <Notification
      message={notificationMessage}
      show={showNotification}
      onClose={handleNotificationClose}
    />
  </div>
  );
}

function ErrorPopup({ message }) {
  return (
    <div className="error-popup">
      <div className="error-popup-arrow"></div>
      <p><span className="yellow-box">!</span>{message}</p>
    </div>
  ); 
}